<mat-toolbar class="header-toolbar">
  <div fxFlex fxLayout="row wrap" fxLayoutAlign="start stretch">
    <span fxFlex="initial" class="header-logo" fxLayout="row" fxLayoutAlign="center center" (click)="navigateTo('/user/region')">
      <img style="height: 40px;" src="../../../../../assets/images/login-logo.png" />
    </span>
    <div fxFlex>
      <header fxLayout="row" fxLayoutAlign="start center" *transloco="let t; read: 'layout.header'">
        <h2 fxFlex="initial" fxHide.xs>{{ t("Welcome") }}</h2>
        <h2 fxFlex="initial" fxHide.gt-xs class="cp-logo">GP</h2>
        <div fxFlex fxLayout fxLayoutAlign="end center" fxLayoutGap="10px" fxLayoutGap.xs="0px"
          class="header-button-nav">
          <span>
            <button mat-icon-button color="primary" [routerLink]="'/user/region'" matTooltip="Home">
              <mat-icon>home</mat-icon>
            </button>
            <button mat-icon-button [matMenuTriggerFor]="languagemenu" class="header-button" *ngIf="false">
              <mat-icon matBadgeSize="medium" matBadgeOverlap="false"
                matBadgePosition="above before">language</mat-icon>
            </button>
            <mat-menu #languagemenu="matMenu" xPosition="before" class="header-menu-panel">
              <button mat-menu-item *ngFor="let lang of languages" (click)="switchLanguage(lang)">
                {{ lang.name }}
              </button>
            </mat-menu>
          </span>
          <span>
            <button mat-icon-button [matMenuTriggerFor]="menu" matTooltip="{{ logedInUserName }}" matTooltipPosition="below">
              <mat-icon>account_circle</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="openChangePasswordDialog()">
                <span><mat-icon>vpn_key</mat-icon></span>
                <span>{{ t("ChangePassword") }}</span>
              </button>
              <button mat-menu-item (click)="userManager()" *ngIf="isAdmin">
                <span>
                  <mat-icon>settings_applications</mat-icon>{{ t("User Manager") }}
                </span>
              </button>
               <button mat-menu-item (click)="Region()" *ngIf="isRegionReviewer">
                <span>
                  <mat-icon>settings_applications</mat-icon>{{ t("Region") }}
                </span>
              </button>
              <button mat-menu-item [routerLink]="[ '/']"  *ngIf="false">
                <span>
                  <mat-icon>contact_support</mat-icon>
                  {{ t('Support')}}
                </span>
              </button>
              <button mat-menu-item (click)="openAboutUsDialog()">
                <mat-icon>info</mat-icon>
                <span>{{ t("About") }}</span>
              </button>
              <button mat-menu-item (click)="logout()">
                <mat-icon>power_settings_new</mat-icon>
                <span>{{ t("SignOut") }}</span>
              </button>
            </mat-menu>
          </span>
        </div>
      </header>
    </div>
  </div>
</mat-toolbar>